"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddressSearchError = void 0;
var _services = require("../../services");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _constants = require("../../utils/constants");
var _useAppDispatch = require("../useAppDispatch");
const useAddressSearchError = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const title = _services.Services.locale.localeString('ErrorPage.AddressSearchHeading');
  const errorMessage = _services.Services.locale.localeString('ErrorPage.AddressSearchMessage');
  const btnText = _services.Services.locale.localeString('ErrorPage.AddressSearchButton');
  const gotoQuestionById = () => {
    dispatch((0, _recommendationActions.goBackToQuestionnaire)());
    dispatch((0, _questionnaireActions.gotoQuestion)(_constants.QUESTION_ID.ADDRESS_SEARCH));
  };
  return {
    title,
    errorMessage,
    btnText,
    gotoQuestionById
  };
};
exports.useAddressSearchError = useAddressSearchError;